"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.component = exports.ExpandCollapseComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var index_1 = require("Views/Partials/Components/KeepTheRhythm/index");
var helpers_1 = require("helpers");
var backgroundImg = 'background-image';
var ExpandCollapseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandCollapseComponent, _super);
    function ExpandCollapseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.expand-collapse-elem';
        _this.expandedClass = 'expand-collapse-item--opened';
        return _this;
    }
    ExpandCollapseComponent.prototype.BeforeInit = function () {
        var _this = this;
        this.el.forEach(function (elem) {
            var externalLink = new app_1.ExternalLink(elem.querySelectorAll('a'));
            externalLink.checkLinks();
        });
        this.$expandItem = $(this.el).find('.expand-collapse-item');
        this.$expandItem.each(function (_i, item) {
            _this.initItem(item);
        });
    };
    ExpandCollapseComponent.prototype.OnInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.checkHash();
            // timeout to complete react header rendering and header animation in ie
        }, 400);
    };
    ExpandCollapseComponent.prototype.OnHashChange = function () {
        this.checkHash();
    };
    ExpandCollapseComponent.prototype.checkHash = function () {
        var hash = window.location.hash;
        if (!hash || hash === '#') {
            return;
        }
        var hashElem = document.querySelector(hash);
        var expandCollapseItem = $(hashElem).closest('.expand-collapse-item').get(0);
        if (expandCollapseItem) {
            var elementContent = expandCollapseItem.getElementsByClassName('item-content')[0];
            var elementItemTitle = expandCollapseItem.querySelector('.item-title');
            expandCollapseItem.classList.add(this.expandedClass);
            elementItemTitle.setAttribute('aria-expanded', 'true');
            var heightValue = elementContent.scrollHeight;
            var onAnimationCompleted = function () {
                if (expandCollapseItem.getElementsByClassName('.ktr').length) {
                    index_1.KTR.SetPendingUpdate();
                    app_1.ComponentService.UpdateComponentsSelector();
                }
            };
            (0, helpers_1.animateElementHeight)(elementContent, heightValue, helpers_1.AnimationDuration.Slow, onAnimationCompleted);
        }
    };
    ExpandCollapseComponent.prototype.initItem = function (item) {
        var _this = this;
        var $el = $(item);
        var $elWithCTAButton = $el.find('.img-empty').next('.cta--play-video');
        var elementItemTitle = item.getElementsByClassName('item-title')[0];
        if (elementItemTitle) {
            elementItemTitle.addEventListener('click', function () {
                return _this.expandCollapseClickHandler(item, elementItemTitle);
            });
            elementItemTitle.addEventListener('keypress', function (e) {
                if (e.key === app_1.keyNameMapping.enter || e.key === app_1.keyNameMapping.space) {
                    e.preventDefault();
                    _this.expandCollapseClickHandler(item, elementItemTitle);
                }
            });
        }
        if ($elWithCTAButton && $elWithCTAButton.length !== 0) {
            this.putImageFromVideo($elWithCTAButton);
        }
    };
    ExpandCollapseComponent.prototype.putImageFromVideo = function ($el) {
        var topProps = {};
        var isValidUrl = webexUI_1.VideoService.checkIsValidVideo($el.attr('data-url'));
        var newSrc;
        if (!isValidUrl) {
            $el.hide();
        }
        newSrc = $el.attr('data-url');
        newSrc = newSrc ? webexUI_1.VideoService.getPreviewImage(newSrc) : null;
        topProps['min-height'] = '360px';
        if (newSrc) {
            topProps[backgroundImg] = "url(".concat(newSrc, ")");
            topProps['background-size'] = 'cover';
        }
        else {
            newSrc = app_1.PathEnum.DefaultVideoImage;
            topProps[backgroundImg] = "url(".concat(newSrc, ")");
        }
        $el.prev('.img-empty').css(topProps);
    };
    ExpandCollapseComponent.prototype.expandCollapseClickHandler = function (element, elementTitle) {
        var isOpened = element.classList.contains(this.expandedClass);
        var elementContent = element.getElementsByClassName('item-content')[0];
        element.classList.toggle(this.expandedClass);
        elementTitle.setAttribute('aria-expanded', (!isOpened).toString());
        var heightValue = isOpened ? 0 : elementContent.scrollHeight;
        var onAnimationCompleted = function () {
            if (element.getElementsByClassName('.ktr').length) {
                index_1.KTR.SetPendingUpdate();
                app_1.ComponentService.UpdateComponentsSelector();
            }
        };
        (0, helpers_1.animateElementHeight)(elementContent, heightValue, helpers_1.AnimationDuration.Slow, onAnimationCompleted);
    };
    return ExpandCollapseComponent;
}(app_1.Component));
exports.ExpandCollapseComponent = ExpandCollapseComponent;
exports.component = new ExpandCollapseComponent();
